<template>
  <v-container fluid>
    <InfoAlert
      :showDismissibleAlert="showDismissibleAlert"
      v-on:close="showDismissibleAlert = false"
      :info="info"
    />
    <v-card
      class="pa-5"
      :dark="$store.getters.getColorPalette().isDark"
      :color="$store.getters.getColorPalette().background2ColorCode"
      flat
    >
      <div class="d-flex justify-space-between">
        <h3 class="pb-2">
          {{ $store.getters.getTextMap().create }}
          {{ $store.getters.getTextMap().log_book }}
          {{ $store.getters.getTextMap().kpis }}
        </h3>
      </div>
      <v-form ref="form" v-model="valid">
        <v-row>
          <v-col v-if="!edit">
            <v-text-field
              :label="$store.getters.getTextMap().kpis"
              v-model="form.kpi"
              dense
              outlined
              :rules="[rules.required]"
            >
            </v-text-field>
          </v-col>
          <v-col>
            <v-autocomplete
              :label="$store.getters.getTextMap().aggregation"
              v-model="form.aggr_func"
              :items="aggrFunctionOptions"
              item-text="label"
              item-value="value"
              dense
              outlined
              :dark="$store.getters.getColorPalette().isDark"
              :color="$store.getters.getColorPalette().inputtextColor"
              :menu-props="{ dark: $store.getters.getColorPalette().isDark }"
              :rules="[rules.required]"
            >
            </v-autocomplete>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col>
            <v-text-field
              :label="$store.getters.getTextMap().column"
              v-model="form.col_no"
              dense
              outlined
              :rules="[rules.required]"
            >
            </v-text-field>
          </v-col>
          <v-col class="mx-1">
            <v-text-field
              :label="$store.getters.getTextMap().multiplier"
              v-model="form.multiplier"
              dense
              outlined
              :rules="[rules.required]"
            >
            </v-text-field>
          </v-col>
          <v-col>
            <v-text-field
              :label="$store.getters.getTextMap().group_by"
              v-model="form.grouping_col_no"
              dense
              outlined
              :rules="[rules.required]"
            >
            </v-text-field>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col cols="12" class="d-flex justify-center pb-5">
            <v-btn
              small
              :color="$store.getters.getColorPalette().submitbtnColor"
              @click="onSubmit"
              class="mr-1"
            >
              {{
                edit
                  ? $store.getters.getTextMap().update
                  : $store.getters.getTextMap().add
              }}
            </v-btn>
            <v-btn
              small
              :color="$store.getters.getColorPalette().cancelbtnColor"
              :dark="$store.getters.getColorPalette().isDark"
              @click="onReset"
            >
              {{ $store.getters.getTextMap().cancel }}
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
      <v-row v-if="!loading && kpiList && kpiList.length > 0">
        <v-col cols="12">
          <v-simple-table height="200px" :style="{ background: 'transparent' }">
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">
                    <strong>{{ $store.getters.getTextMap().kpis }}</strong>
                  </th>
                  <th class="text-left">
                    <strong>{{
                      $store.getters.getTextMap().aggregation
                    }}</strong>
                  </th>
                  <th class="text-left">
                    <strong>{{ $store.getters.getTextMap().column }}</strong>
                  </th>
                  <th class="text-left">
                    <strong>{{
                      $store.getters.getTextMap().multiplier
                    }}</strong>
                  </th>
                  <th class="text-left">
                    <strong>{{ $store.getters.getTextMap().group_by }}</strong>
                  </th>
                  <th class="text-left">
                    <strong>{{ $store.getters.getTextMap().action }}</strong>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr :key="item.kpi" v-for="item in kpiList">
                  <td>{{ item.kpi }}</td>
                  <td>{{ item.aggr_func }}</td>
                  <td>{{ item.col_no }}</td>
                  <td>{{ item.multiplier }}</td>
                  <td>{{ item.grouping_col_no }}</td>
                  <td>
                    <v-icon
                      @click="startEdit(item)"
                      small
                      color="primary"
                      class="mr-2"
                    >
                      mdi-pencil
                    </v-icon>
                    <DeleteConfirmation
                      v-on:confirm="deleteKPI(item)"
                      title="Delete Confirmation"
                      description="Are you sure you want to delete this KPI?"
                    >
                      <v-icon small color="red"> mdi-delete </v-icon>
                    </DeleteConfirmation>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-col>
      </v-row>
      <v-row v-else>
        <v-col>
          <div
            :style="[
              {
                padding: '10px',
                display: 'flex',
                'justify-content': 'center',
                color: $store.getters.getColorPalette().accentCode,
              },
            ]"
          >
            <v-icon :dark="$store.getters.getColorPalette().isDark" class="mr-3"
              >mdi-database-remove-outline</v-icon
            >
            <h3>{{ $store.getters.getTextMap().no_data_available }}</h3>
          </div>
        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>
<script>
import InfoAlert from "@/components/InfoAlert";
import FormRules from "@/utillities/FormRules";
import DeleteConfirmation from "@/components/DeleteConfirmation";
import axios from "axios";
export default {
  name: "CreateManufacturingLogbookKPI",
  props: ["logbook"],
  components: {
    InfoAlert,
    DeleteConfirmation,
  },
  data() {
    return {
      showDismissibleAlert: false,
      info: "",
      loading: false,
      edit: false,
      valid: false,
      rules: FormRules.rules,
      kpiList: [],
      endpoint: "createManufacturingLogbookKPI",
      form: {
        kpi: null,
        aggr_func: "sum",
        col_no: 1,
        multiplier: 1,
        grouping_col_no: 1,
      },
      aggrFunctionOptions: [
        { label: "Count", value: "count" },
        { label: "Summation", value: "sum" },
        { label: "Average", value: "avg" },
        { label: "First", value: "first" },
        { label: "Last", value: "last" },
      ],
    };
  },
  mounted() {
    if (this.logbook && this.logbook.logbook_id) {
      this.init();
    }
  },
  methods: {
    init() {
      this.kpiList = [];
      this.loading = true;
      axios
        .post(
          this.$store.state.api + "getManufacturingLogbookKPIsByLogbookid",
          { logbook_id: this.logbook.logbook_id },
          {
            headers: {
              Authorization: "Bearer " + this.$store.state.jwt,
            },
          }
        )
        .then((response) => {
          if (response.data.status === "success") {
            if (response.data.data.length > 0) {
              this.kpiList = response.data.data;
            }
          } else {
            this.info = response.data.msg;
            this.showDismissibleAlert = true;
          }
          this.loading = false;
        })
        .catch((err) => {
          console.error(err);
          this.info = err;
          this.showDismissibleAlert = true;
          this.loading = false;
        });
    },
    startEdit(item) {
      this.edit = true;
      this.form = JSON.parse(JSON.stringify(item));
      this.endpoint = "updateManufacturingLogbookKPI";
    },
    onSubmit() {
      this.$refs.form.validate();
      if (this.valid) {
        this.loading = true;
        let payload = { ...this.form };
        payload["logbook_id"] = this.logbook.logbook_id;
        axios
          .post(this.$store.state.api + this.endpoint, payload, {
            headers: {
              Authorization: "Bearer " + this.$store.state.jwt,
            },
          })
          .then((response) => {
            if (response.data.status === "success") {
              this.init();
              this.onReset();
              this.loading = false;
            } else {
              this.info = response.data.msg;
              this.showDismissibleAlert = true;
              this.loading = false;
            }
            this.loading = false;
          })
          .catch((err) => {
            this.showDismissibleAlert = true;
            this.info = err;
            this.loading = false;
          });
      }
    },
    deleteKPI(item) {
      this.loading = true;
      let payload = {
        logbook_id: this.logbook.logbook_id,
        kpi: item.kpi,
      };
      axios
        .post(
          this.$store.state.api + "deleteManufacturingLogbookKPI",
          payload,
          {
            headers: {
              Authorization: "Bearer " + this.$store.state.jwt,
            },
          }
        )
        .then((response) => {
          if (response.data.status === "success") {
            this.init();
            this.onReset();
            this.loading = false;
          } else {
            this.info = response.data.msg;
            this.showDismissibleAlert = true;
            this.loading = false;
          }
          this.loading = false;
        })
        .catch((err) => {
          this.showDismissibleAlert = true;
          this.info = err;
          this.loading = false;
        });
    },
    onReset() {
      this.edit = false;
      this.endpoint = "createManufacturingLogbookKPI";
      this.$refs.form.reset();
    },
  },
  watch: {
    logbook: {
      handler() {
        if (this.logbook && this.logbook.logbook_id) {
          this.init();
        }
      },
      deep: true,
    },
  },
};
</script>
